import { render, staticRenderFns } from "./ButtonSearch.vue?vue&type=template&id=63d08f17&scoped=true&lang=pug"
import script from "./ButtonSearch.vue?vue&type=script&lang=ts"
export * from "./ButtonSearch.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSearch.vue?vue&type=style&index=0&id=63d08f17&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d08f17",
  null
  
)

export default component.exports